import React from 'react';
import PropTypes from 'prop-types';
import Flyout from '../Flyout';

import {Link} from 'react-router';

import Api from '../../Api';

export default class User extends React.Component {
  static contextTypes = {
    router: PropTypes.object
  };

  constructor(props) {
    super(props);

    Api.Utils.bindThis(
      this,
      [
        'onRetailerNameClick',
        'onPopupMenuClose',
        'updateOrderList',
        'onNotYouClicked',
        'onImpersonate',
        'onUnimpersonate',
        'onRecommendAllProducts',
        'onRemoveAllManualRecommendations',
        'onKeyDown'
      ]
    );

    this.state = {
      opened: false,
      user: props.user,
      userOrders: null,
      adminBarVisible: Api.cache.getAdminBarVisible()
    };
  }

  componentWillMount() {
    document.addEventListener("keydown", this.onKeyDown);
    this.updateOrderList();

    Api.startListen(this, 'adminBarVisible', Api.cache.eventTypes.ADMIN_BAR_VISIBILITY_CHANGED);
    Api.startListen(this, 'userOrders', Api.cache.eventTypes.ORDER_LIST_CHANGED);
  }

  componentWillReceiveProps(newProps) {
    if (newProps.location && this.props.location && this.props.location.pathname !== newProps.location.pathname) {
      this.onPopupMenuClose();
    }

    if (newProps.user !== this.state.user) {
      this.setState({
        user: newProps.user
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.props.user || !prevProps.user || prevProps.user.token !== this.props.user.token) {
      this.updateOrderList();
    }
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.onKeyDown);

    Api.stopListen(this, Api.cache.eventTypes.ADMIN_BAR_VISIBILITY_CHANGED);
    Api.stopListen(this, Api.cache.eventTypes.ORDER_LIST_CHANGED);
  }

  onKeyDown(event) {
    if (event.key === 'Escape' && this.state.opened) {
      this.setState({opened: false});
      event.preventDefault();
    }
  }

  updateOrderList() {
    if (!this.state.user) {
      if (this.state.userOrders) {
        this.setState({userOrders: null});
      }
      return;
    }

    Api.getOrders().then(
      (orderList) => {
        this.setState({userOrders: orderList});
      }
    );
  }

  onRetailerNameClick(event) {
    if (event) event.preventDefault();
    this.setState({
      opened: !this.state.opened
    });
  }

  onPopupMenuClose(event) {
    if (event) event.preventDefault();
    this.setState({
      opened: false
    });
  }

  onNotYouClicked() {
    return Api.resetLastSelectedRetailer().then(() => {
      this.context.router.push('/');
    });
  }

  onImpersonate() {
    return Api.impersonateUserByToken(this.props.retailer.owner_user_token).then(() => {
      this.context.router.push('/');
    });
  }

  onUnimpersonate() {
    return Api.unimpersonateUser().then(() => {
      this.context.router.push('/');
    });
  }

  onRecommendAllProducts() {
    this.setState({
      opened: false
    });

    let tokensToRecommend = [];
    let recommendations = Api.cache.getRecommendations();
    if (recommendations.response.products) {
      Object.keys(recommendations.response.products).forEach((token) => {
        let product = recommendations.response.products[token];
        if (product.auto_recommendation && !product.manual_recommendation) {
          tokensToRecommend.push(product.token);
        }
      });
    }

    if (tokensToRecommend.length > 0) {
      Api.retailerAddRecommendations(this.props.retailer.token, tokensToRecommend)
        .then(() => Api.refreshCurrentRecommendations())
        .catch((error) => {
          alert("Error adding manual recommendations: " + error.response.message);
        });
    }
  }

  onRemoveAllManualRecommendations() {
    this.setState({
      opened: false
    });

    Api.retailerClearRecommendations(this.props.retailer.token)
      .then(() => Api.refreshCurrentRecommendations())
      .catch((error) => {
          alert("Error removing manual recommendations: " + error.response.message);
      });
  }

  toggleAdminBar() {
    Api.cache.setAdminBarVisible(!Api.cache.getAdminBarVisible());
  }

  render() {
    if (!this.props.retailer) return null;

    let state = this.state;
    let isEmployee = state.user && state.user.is_employee;
    let hasOrders = state.userOrders && state.userOrders.orders && state.userOrders.orders.length > 0;

    let orderHistory = null;
    let paymentOptions = null;
    if (isEmployee || hasOrders) {
      orderHistory = <li><Link to="/user/account">Order History</Link></li>;
    }

    if (state.user) {
      paymentOptions = <li><Link to="/user/account/payments">Payment Options</Link></li>;
    }

    let goToAdmin = null;
    let forgetRetailer = null;
    let carriedBrands = null;
    let retailerWebsite = null;
    let impersonate = null;
    let recommendAllProducts = null;
    let removeAllManualRecommendations = null;
    let recommendationsInfo = null;
    let adminBarToggle = null;
    if (isEmployee) {
      goToAdmin = <li className="admin"><Link to="/admin">Go To Admin</Link></li>;
      retailerWebsite = this.props.retailer.url !== null
        ? <li className="admin"><a href={this.props.retailer.url} target="_blank">Retailer Website</a></li>
        : null;
      carriedBrands = <li className="admin"><a href="/api/leads/carried-brands" target="_blank">Carried Brands</a></li>;
      forgetRetailer =
        <li className="admin" style={{cursor: 'pointer'}} onClick={this.onNotYouClicked}>
          Forget {this.props.retailer.name}</li>;

      if (this.props.retailer.owner_user_token) {
        impersonate =
          <li className="admin" style={{cursor: 'pointer'}} onClick={this.onImpersonate}>
            Impersonate {this.props.retailer.name} ({this.props.retailer.owner_user_token})</li>;
      }

      adminBarToggle = <li className="admin link" onClick={this.toggleAdminBar}>{this.state.adminBarVisible ? 'Hide' : 'Show'} admin bar</li>;
      removeAllManualRecommendations = <li className="admin" style={{cursor: 'pointer'}}
                                           onClick={this.onRemoveAllManualRecommendations}>
        Remove all manual recommendations</li>;
      if (Api.cache.hasProductRecommendations()) {
        let active = 0;
        let inactive = 0;
        let auto = 0;
        let manual = 0;
        let recent = 0;
        let autoNotManual = 0;
        let recommendations = Api.cache.getRecommendations();
        if (recommendations && recommendations.response) {
          recommendations = recommendations.response;

          if (recommendations.display_order) {
            recommendations.display_order.forEach(displayToken => {
              let displayObject = recommendations.products[displayToken];
              if (!displayObject) {
                if (!recommendations.collections[displayToken]) {
                  console.error("cannot find product or collection with token %s", displayToken);
                }
                return;
              }

              if (displayObject.active) {
                active++
              } else {
                inactive++;
              }
              if (displayObject.auto_recommendation) auto++;
              if (displayObject.manual_recommendation) manual++;
              if (displayObject.recently_ordered) recent++;
              if (displayObject.auto_recommendation && !displayObject.manual_recommendation) autoNotManual++;
            });
          }

          recommendationsInfo =
            <li className="admin">Active: {active}, Inactive: {inactive}, Auto: {auto},
              Manual: {manual}, Recent: {recent}</li>;

          if (autoNotManual > 0) {
            recommendAllProducts = <li className="admin" style={{cursor: 'pointer'}}
                                       onClick={this.onRecommendAllProducts}>
              Recommend {autoNotManual} products</li>;
          }
          removeAllManualRecommendations = <li className="admin" style={{cursor: 'pointer'}}
                                               onClick={this.onRemoveAllManualRecommendations}>
            Remove {manual} manual recommendations</li>;
        }
      }
    }

    let impersonating = state.user && state.user.impersonating === true;
    let paymentStatus = null;
    let unimpersonate = null;
    if (impersonating) {
      unimpersonate =
        <li className="admin" style={{cursor: 'pointer'}} onClick={this.onUnimpersonate}>
          Unimpersonate {state.user.name}</li>;
      if (this.state.user.retailer_token) {
        paymentStatus =
          <li className="admin" style={{cursor: 'pointer'}}>
            <Link to="/user/account/status">Payment Status</Link>
          </li>;
      }
    }

    let popupMenu = null;
    if (state.opened && state.user) {
      popupMenu =
        <Flyout className="user-flyout" onClose={this.onPopupMenuClose}>
          <ul>
            {orderHistory}
            {paymentOptions}
            <li onClick={this.onNotYouClicked} className="responsive-mobile link">Not You?</li>
            <li><Link to="/user/logout">Log out</Link></li>

            {goToAdmin}
            {carriedBrands}
            {retailerWebsite}
            {forgetRetailer}
            {paymentStatus}
            {impersonate}
            {unimpersonate}
            {recommendationsInfo}
            {recommendAllProducts}
            {removeAllManualRecommendations}
            {adminBarToggle}
          </ul>
        </Flyout>;
    }

    let notYou = null;
    if (!state.user) {
      notYou =
        <span className="not-you link responsive-desktop" onClick={this.onNotYouClicked}>
          Not You?
        </span>;
    }

    let displayName = impersonating
      ? this.props.retailer.name + " - IMPERSONATING: " + state.user.name
      : this.props.retailer.name + (isEmployee ? " - AS ADMIN" : "");

    return (
      <div className="userheader-component">
        <span className="link header-bars responsive-mobile" onClick={this.onRetailerNameClick}/>
        <span className="link responsive-desktop" onClick={this.onRetailerNameClick}>{displayName}</span>
        {popupMenu}
        {notYou}
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Header/user.js
 **/